// Curated, cross-linked mock catalog for IndiasCinema.com — the Knowledge Graph in miniature.

const IMG = "https://static.prod-images.emergentagent.com/jobs/c6af1a77-2b65-44c2-9c4e-049400224684/images/";
const POSTERS = {
  monsoon: IMG + "1ba9034ca1d3bdb36deec5dc31d816f78da968979a95eda9e60fa726b3abaded.jpeg",
  neon: IMG + "51fae2e1463998b14def6426026b9bef68090912ad6fa601222488455669d798.jpeg",
  river: IMG + "178d4482be853f336d5914717851cccfaf785f0e86355844674ffc0f5daa4147.jpeg",
  coast: IMG + "c3645a97d2e221d39cd0a8337546249c1c93088f4ce3f9c7be259cf05afa9865.jpeg",
  raga: IMG + "de81f61c1a7ca2430ca50ccb3c37ee69b2baa73fa0bbc13d2c1e67f4f94ece88.jpeg",
  desert: IMG + "da1215a9c25d57e0afeb58d26288c7660e649f44a35791c04961074c067258d1.jpeg",
  temple: IMG + "2bcfbfd6f76ea31645404248f49ea8f56759fcf50222994364beb742b50a305e.jpeg",
};

export const LANGUAGES = [
  { code: "en", name: "English", native: "English", indian: false },
  { code: "hi", name: "Hindi", native: "हिन्दी", indian: true },
  { code: "ml", name: "Malayalam", native: "മലയാളം", indian: true },
  { code: "ta", name: "Tamil", native: "தமிழ்", indian: true },
  { code: "te", name: "Telugu", native: "తెలుగు", indian: true },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ", indian: true },
  { code: "bn", name: "Bengali", native: "বাংলা", indian: true },
  { code: "mr", name: "Marathi", native: "मराठी", indian: true },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી", indian: true },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ", indian: true },
  { code: "or", name: "Odia", native: "ଓଡ଼ିଆ", indian: true },
  { code: "as", name: "Assamese", native: "অসমীয়া", indian: true },
  { code: "ur", name: "Urdu", native: "اردو", indian: true, rtl: true },
  { code: "ne", name: "Nepali", native: "नेपाली", indian: true },
  { code: "sa", name: "Sanskrit", native: "संस्कृतम्", indian: true },
  { code: "kok", name: "Konkani", native: "कोंकणी", indian: true },
  { code: "es", name: "Spanish", native: "Español", indian: false },
  { code: "fr", name: "French", native: "Français", indian: false },
  { code: "de", name: "German", native: "Deutsch", indian: false },
  { code: "it", name: "Italian", native: "Italiano", indian: false },
  { code: "pt", name: "Portuguese", native: "Português", indian: false },
  { code: "ar", name: "Arabic", native: "العربية", indian: false, rtl: true },
  { code: "zh", name: "Chinese", native: "中文", indian: false },
  { code: "ja", name: "Japanese", native: "日本語", indian: false },
  { code: "ko", name: "Korean", native: "한국어", indian: false },
  { code: "ru", name: "Russian", native: "Русский", indian: false },
  { code: "mai", name: "Maithili", native: "मैथिली", indian: true },
  { code: "sat", name: "Santali", native: "ᱥᱟᱱᱛᱟᱲᱤ", indian: true },
  { code: "ks", name: "Kashmiri", native: "کٲشُر", indian: true, rtl: true },
  { code: "sd", name: "Sindhi", native: "سنڌي", indian: true, rtl: true },
  { code: "doi", name: "Dogri", native: "डोगरी", indian: true },
  { code: "mni", name: "Manipuri", native: "মৈতৈলোন্", indian: true },
  { code: "brx", name: "Bodo", native: "बर'", indian: true },
  { code: "bho", name: "Bhojpuri", native: "भोजपुरी", indian: true },
  { code: "tcy", name: "Tulu", native: "ತುಳು", indian: true },
  { code: "fa", name: "Persian", native: "فارسی", indian: false, rtl: true },
  { code: "tr", name: "Turkish", native: "Türkçe", indian: false },
  { code: "nl", name: "Dutch", native: "Nederlands", indian: false },
  { code: "id", name: "Indonesian", native: "Indonesia", indian: false },
  { code: "th", name: "Thai", native: "ไทย", indian: false },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt", indian: false },
  { code: "pl", name: "Polish", native: "Polski", indian: false },
  { code: "sw", name: "Swahili", native: "Kiswahili", indian: false },
  { code: "uk", name: "Ukrainian", native: "Українська", indian: false },
];

export const REGIONS = [
  { lang: "Malayalam", native: "മലയാളം", films: "12,400+", note: "The new wave capital" },
  { lang: "Hindi", native: "हिन्दी", films: "38,200+", note: "Bombay to the world" },
  { lang: "Tamil", native: "தமிழ்", films: "24,800+", note: "Kollywood spectacle" },
  { lang: "Telugu", native: "తెలుగు", films: "21,600+", note: "Pan-Indian powerhouse" },
  { lang: "Kannada", native: "ಕನ್ನಡ", films: "9,700+", note: "Sandalwood rising" },
  { lang: "Bengali", native: "বাংলা", films: "11,300+", note: "The auteur's homeland" },
  { lang: "Marathi", native: "मराठी", films: "8,100+", note: "Rooted realism" },
  { lang: "Punjabi", native: "ਪੰਜਾਬੀ", films: "5,400+", note: "Rhythm & heart" },
];

// Portrait pool
const P = {
  kabir: "https://images.unsplash.com/photo-1598444528046-0fc784a8234c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  aditi: "https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=760",
  meera: "https://images.unsplash.com/photo-1727293375491-f683bfcbe6ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  vikram: "https://images.unsplash.com/photo-1587397845856-e6cf49176c70?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  chandran: "https://images.pexels.com/photos/30743729/pexels-photo-30743729.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=760",
  leela: "https://images.unsplash.com/photo-1771620955155-7ff9b5d16803?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  sanjay: "https://images.unsplash.com/photo-1532170579297-281918c8ae72?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  noor: "https://images.unsplash.com/photo-1769650795527-a707e63754a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  arjun: "https://images.unsplash.com/photo-1450133064473-71024230f91b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  pandit: "https://images.pexels.com/photos/33523784/pexels-photo-33523784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=760",
};

export const PEOPLE = [
  { id: "p1", name: "Kabir Menon", role: "Director", image: P.kabir, langs: ["Malayalam", "Hindi"], born: "1979 · Kochi",
    bio: "A defining voice of the Malayalam new wave, Kabir Menon is known for taut, humane thrillers that blur the line between the everyday and the extraordinary. His frames are quiet; his tension is not.",
    filmography: ["m1", "m4"], collaborators: ["p2", "p4", "p7"], awards: ["National Award — Best Director (2024)", "Kerala State Film Award"] },
  { id: "p2", name: "Aditi Rao", role: "Playback Singer", image: P.aditi, langs: ["Malayalam", "Tamil", "Hindi"], born: "1990 · Thrissur",
    bio: "One of the most sought-after playback voices in South India, Aditi Rao pairs a crystalline upper register with an intimacy that has redefined the modern film ballad.",
    filmography: ["m1", "m3"], collaborators: ["p5", "p1"], awards: ["Filmfare South — Best Female Playback"] },
  { id: "p3", name: "Meera Nair", role: "Actress", image: P.meera, langs: ["Hindi", "Marathi"], born: "1993 · Mumbai",
    bio: "Equal parts luminous and fearless, Meera Nair chooses roles that unsettle. Her turn in Neon Bazaar cemented her as the face of a bolder Hindi cinema.",
    filmography: ["m2", "m5"], collaborators: ["p9", "p5"], awards: ["Filmfare — Best Actress (Critics)"] },
  { id: "p4", name: "Vikram Suresh", role: "Actor", image: P.vikram, langs: ["Malayalam", "Tamil"], born: "1985 · Chennai",
    bio: "A performer of restrained intensity, Vikram Suresh has become the quiet centre of gravity in a run of acclaimed thrillers and epics.",
    filmography: ["m1", "m3"], collaborators: ["p1", "p2"], awards: ["State Award — Best Actor"] },
  { id: "p5", name: "R. Chandran", role: "Music Director", image: P.chandran, langs: ["Malayalam", "Tamil", "Hindi"], born: "1972 · Madurai",
    bio: "A composer who treats the soundtrack as a character. Chandran fuses Carnatic phrasing with cinematic scoring, and his collaborations with Aditi Rao are modern classics.",
    filmography: ["m1", "m3", "m5"], collaborators: ["p2", "p8"], awards: ["National Award — Best Music Direction"] },
  { id: "p6", name: "Leela Krishnan", role: "Actress", image: P.leela, langs: ["Telugu", "Tamil"], born: "1996 · Hyderabad",
    bio: "A breakout star of Telugu mystery cinema, Leela Krishnan brings a watchful, magnetic stillness to the screen.",
    filmography: ["m4"], collaborators: ["p1"], awards: ["SIIMA — Best Debut"] },
  { id: "p7", name: "Sanjay Pillai", role: "Cinematographer", image: P.sanjay, langs: ["Malayalam"], born: "1981 · Kollam",
    bio: "The eye behind the monsoon. Sanjay Pillai paints with available light, and his rain-soaked frames have become a signature of contemporary Malayalam cinema.",
    filmography: ["m1", "m4"], collaborators: ["p1"], awards: ["Kerala State Award — Best Cinematography"] },
  { id: "p8", name: "Noor Kaur", role: "Independent Singer", image: P.noor, langs: ["Hindi", "Punjabi"], born: "1997 · Amritsar",
    bio: "The vanguard of Indie India — Noor Kaur writes and produces her own genre-fluid records, and lends her smoky voice to select film projects.",
    filmography: ["m2"], collaborators: ["p5"], awards: ["Indie Music Award — Artist of the Year"] },
  { id: "p9", name: "Arjun Dev", role: "Actor", image: P.arjun, langs: ["Hindi"], born: "1988 · Delhi",
    bio: "A chameleon of Hindi cinema, Arjun Dev disappears into every role, from noir anti-heroes to desert wanderers.",
    filmography: ["m2", "m6"], collaborators: ["p3"], awards: ["Filmfare — Best Actor"] },
  { id: "p10", name: "Pandit R. Sharma", role: "Classical Composer", image: P.pandit, langs: ["Hindi", "Sanskrit"], born: "1958 · Varanasi",
    bio: "A custodian of the Hindustani tradition whose concert-length ragas have found a new home among a generation of streaming listeners.",
    filmography: [], collaborators: [], awards: ["Padma honouree", "Sangeet Natak Akademi Award"] },
];

const dims = (s, a, d, m, c, e, ci) => ({ Story: s, Acting: a, Direction: d, Music: m, Cinematography: c, Entertainment: e, "Cultural Impact": ci });

export const MOVIES = [
  {
    id: "m1", title: "The Last Monsoon", language: "Malayalam", year: "2024", genre: "Drama · Thriller",
    runtime: "2h 18m", cert: "U/A", rating: "8.7", accent: "#2FA8A0", image: POSTERS.monsoon,
    synopsis: "When the year's final monsoon traps a small hill town, a retired schoolteacher must confront a secret the rain has kept buried for two decades. A slow-burn thriller about memory, guilt and the things water remembers.",
    cast: [{ p: "p4", as: "Ravi Menon" }, { p: "p3", as: "Kamala" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: ["s1", "s5"],
    whereToWatch: [{ name: "JioHotstar", type: "Stream" }, { name: "Prime Video", type: "Rent" }, { name: "Theatres", type: "Now Showing" }],
    boxOffice: { budget: "₹9 Cr", india: "₹68 Cr", worldwide: "₹104 Cr", status: "Verified" },
    awards: ["National Award — Best Director", "3 Kerala State Awards"],
    trivia: ["Shot almost entirely during real monsoon showers over 47 days.", "The lead's umbrella was hand-made by a local artisan in Thrissur."],
    reviewDims: dims(9, 9, 10, 8, 10, 7, 9), related: ["m4", "m3"],
  },
  {
    id: "m2", title: "Neon Bazaar", language: "Hindi", year: "2025", genre: "Crime · Noir",
    runtime: "2h 32m", cert: "A", rating: "8.2", accent: "#E0457B", image: POSTERS.neon,
    synopsis: "In the electric underbelly of a city that never sleeps, a small-time fixer and a fearless journalist are pulled into a single night that will burn everything they know. Rain, neon and betrayal.",
    cast: [{ p: "p9", as: "Salim" }, { p: "p3", as: "Nadia" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: ["s3", "s6"],
    whereToWatch: [{ name: "Netflix", type: "Stream" }, { name: "YouTube", type: "Buy" }],
    boxOffice: { budget: "₹42 Cr", india: "₹121 Cr", worldwide: "₹190 Cr", status: "Estimated" },
    awards: ["Filmfare — Best Cinematography (Nominee)"],
    trivia: ["The neon market set took 90 days to build.", "Over 400 practical neon signs were used on set."],
    reviewDims: dims(8, 9, 8, 9, 9, 8, 7), related: ["m4", "m6"],
  },
  {
    id: "m3", title: "River of Stars", language: "Tamil", year: "2024", genre: "Epic · Adventure",
    runtime: "2h 51m", cert: "U", rating: "8.9", accent: "#E8873A", image: POSTERS.river,
    synopsis: "A sweeping period epic following a boatman who carries a deposed prince down a sacred river toward an uncertain dawn — and a country's future in his oars.",
    cast: [{ p: "p4", as: "Kannan" }, { p: "p6", as: "Ponni" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: ["s2", "s8"],
    whereToWatch: [{ name: "Prime Video", type: "Stream" }, { name: "Sun NXT", type: "Stream" }],
    boxOffice: { budget: "₹120 Cr", india: "₹310 Cr", worldwide: "₹520 Cr", status: "Verified" },
    awards: ["National Award — Best Music Direction", "5 SIIMA Awards"],
    trivia: ["The climactic river sequence was filmed across three states.", "6,000 costumes were hand-woven for the film."],
    reviewDims: dims(9, 8, 9, 10, 9, 9, 9), related: ["m1", "m6"],
  },
  {
    id: "m4", title: "Silent Coast", language: "Telugu", year: "2025", genre: "Mystery",
    runtime: "2h 09m", cert: "U/A", rating: "7.9", accent: "#3B6EA5", image: POSTERS.coast,
    synopsis: "A marine biologist returns to her fog-bound coastal village to investigate a disappearance, only to find the sea guards its own kind of silence.",
    cast: [{ p: "p6", as: "Dr. Anjali" }, { p: "p4", as: "Inspector Rao" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: [],
    whereToWatch: [{ name: "aha", type: "Stream" }, { name: "ZEE5", type: "Stream" }],
    boxOffice: { budget: "₹22 Cr", india: "₹54 Cr", worldwide: "₹71 Cr", status: "Estimated" },
    awards: ["SIIMA — Best Debut (Leela Krishnan)"],
    trivia: ["The fog was almost entirely natural, captured at dawn.", "Underwater scenes were shot off the Vizag coast."],
    reviewDims: dims(8, 8, 8, 7, 9, 7, 7), related: ["m1", "m2"],
  },
  {
    id: "m5", title: "Aurora Raga", language: "Hindi", year: "2024", genre: "Musical · Drama",
    runtime: "2h 24m", cert: "U", rating: "8.4", accent: "#C0392B", image: POSTERS.raga,
    synopsis: "A classical vocalist on the edge of fame must choose between the purity of her art and the roar of the industry. A love letter to Indian music.",
    cast: [{ p: "p3", as: "Ira" }, { p: "p9", as: "Dev" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: ["s4"],
    whereToWatch: [{ name: "SonyLIV", type: "Stream" }, { name: "Prime Video", type: "Rent" }],
    boxOffice: { budget: "₹30 Cr", india: "₹88 Cr", worldwide: "₹132 Cr", status: "Verified" },
    awards: ["National Award — Best Female Playback"],
    trivia: ["Every song was recorded live on set.", "The lead trained in Hindustani vocals for a year."],
    reviewDims: dims(8, 9, 8, 10, 8, 8, 9), related: ["m3", "m1"],
  },
  {
    id: "m6", title: "Desert Verse", language: "Rajasthani", year: "2025", genre: "Drama",
    runtime: "1h 58m", cert: "U", rating: "8.0", accent: "#8E44AD", image: POSTERS.desert,
    synopsis: "A wandering folk poet crosses the Thar in search of a song he heard once as a child — and finds a country changing beneath the same endless sky.",
    cast: [{ p: "p9", as: "Mohan" }, { p: "p6", as: "Reva" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: ["s7"],
    whereToWatch: [{ name: "Netflix", type: "Stream" }, { name: "Theatres", type: "Now Showing" }],
    boxOffice: { budget: "₹14 Cr", india: "₹41 Cr", worldwide: "₹60 Cr", status: "Estimated" },
    awards: ["Best Feature — Indie Film Festival"],
    trivia: ["Filmed during a rare desert bloom.", "The folk melodies are based on real Manganiyar songs."],
    reviewDims: dims(9, 8, 8, 9, 9, 7, 8), related: ["m3", "m5"],
  },
  {
    id: "m7", title: "Cosmic Temple", language: "Kannada", year: "2025", genre: "Sci-Fi",
    runtime: "2h 40m", cert: "U/A", rating: "8.1", accent: "#6C5CE7", image: POSTERS.temple,
    synopsis: "In a neon-drenched future Bengaluru, an archaeologist discovers that an ancient temple is in fact a dormant machine — and it has begun to wake.",
    cast: [{ p: "p4", as: "Adith" }, { p: "p6", as: "Maya" }],
    crew: { Director: "p1", Music: "p5", Cinematography: "p7" },
    songs: [],
    whereToWatch: [{ name: "Prime Video", type: "Stream" }, { name: "Theatres", type: "Now Showing" }],
    boxOffice: { budget: "₹95 Cr", india: "₹180 Cr", worldwide: "₹300 Cr", status: "Estimated" },
    awards: ["Best VFX — Nominee"],
    trivia: ["Blends real temple architecture with speculative design.", "The score uses a 60-piece orchestra and synths."],
    reviewDims: dims(8, 8, 8, 8, 9, 9, 8), related: ["m4", "m3"],
  },
];

export const SONGS = [
  { id: "s1", title: "Mazhavil", movie: "m1", singer: "p2", composer: "p5", lyricist: "p1", language: "Malayalam", year: "2024", genre: "Film", mood: "Melancholic", duration: "4:12" },
  { id: "s2", title: "Kaadhal Neruppu", movie: "m3", singer: "p2", composer: "p5", lyricist: "p1", language: "Tamil", year: "2024", genre: "Film", mood: "Romantic", duration: "3:48" },
  { id: "s3", title: "Raat Rani", movie: "m2", singer: "p8", composer: "p5", lyricist: "p8", language: "Hindi", year: "2025", genre: "Indie", mood: "Sultry", duration: "3:21" },
  { id: "s4", title: "Megha Sandesh", movie: "m5", singer: "p10", composer: "p10", lyricist: "p10", language: "Hindi", year: "2024", genre: "Hindustani", mood: "Meditative", duration: "6:05" },
  { id: "s5", title: "Kadal Pearl", movie: "m1", singer: "p2", composer: "p5", lyricist: "p1", language: "Malayalam", year: "2024", genre: "Fusion", mood: "Uplifting", duration: "4:37" },
  { id: "s6", title: "Neon Nights", movie: "m2", singer: "p8", composer: "p5", lyricist: "p8", language: "Hindi", year: "2025", genre: "Film", mood: "Electric", duration: "3:59" },
  { id: "s7", title: "Desert Wind", movie: "m6", singer: "p8", composer: "p5", lyricist: "p9", language: "Rajasthani", year: "2025", genre: "Folk", mood: "Yearning", duration: "4:02" },
  { id: "s8", title: "Star River", movie: "m3", singer: "p2", composer: "p5", lyricist: "p1", language: "Tamil", year: "2024", genre: "Film", mood: "Epic", duration: "5:14" },
];

// Section-friendly derived lists (keep existing components working)
export const ARTISTS = [PEOPLE[0], PEOPLE[1], PEOPLE[2], PEOPLE[4]].map((p) => ({ id: p.id, name: p.name, role: p.role, image: p.image }));

export const TIMELINE = [
  { year: "1913", title: "Raja Harishchandra", note: "India's first full-length feature film." },
  { year: "1931", title: "The Talkies Arrive", note: "Alam Ara brings sound to Indian screens." },
  { year: "1955", title: "The Golden Era", note: "Parallel cinema and the auteur emerges." },
  { year: "1975", title: "Masala Spectacle", note: "The pan-Indian blockbuster is born." },
  { year: "2010", title: "New Wave", note: "Regional cinema redefines storytelling." },
  { year: "2020", title: "The Streaming Age", note: "Indian cinema goes truly global." },
];

export const STATS = [
  { value: "2,000+", label: "Films released each year" },
  { value: "30+", label: "Languages & cinemas" },
  { value: "50M+", label: "Global fans & diaspora" },
  { value: "120yr", label: "Of cinematic history" },
];

// India Cinema Today — live dashboard concept from the strategy brief
export const TODAY = [
  { value: "42", label: "Films updating" },
  { value: "127", label: "New songs" },
  { value: "18", label: "OTT releases" },
  { value: "31", label: "Trailers" },
  { value: "8", label: "Awards & events" },
];

// Lookups
export const getMovie = (id) => MOVIES.find((m) => m.id === id);
export const getPerson = (id) => PEOPLE.find((p) => p.id === id);
export const getSong = (id) => SONGS.find((s) => s.id === id);
export const moviesForPerson = (id) => MOVIES.filter((m) => (getPerson(id)?.filmography || []).includes(m.id));
export const songsForPerson = (id) => SONGS.filter((s) => s.singer === id || s.composer === id || s.lyricist === id);

export const ALBUMS = [
  { id: "al1", title: "The Last Monsoon", type: "Original Soundtrack", movie: "m1", artist: "p5", year: "2024", language: "Malayalam", cover: POSTERS.monsoon, songs: ["s1", "s5"] },
  { id: "al2", title: "River of Stars", type: "Original Soundtrack", movie: "m3", artist: "p5", year: "2024", language: "Tamil", cover: POSTERS.river, songs: ["s2", "s8"] },
  { id: "al3", title: "Neon Bazaar", type: "Original Soundtrack", movie: "m2", artist: "p5", year: "2025", language: "Hindi", cover: POSTERS.neon, songs: ["s3", "s6"] },
  { id: "al4", title: "Aurora Raga", type: "Original Soundtrack", movie: "m5", artist: "p5", year: "2024", language: "Hindi", cover: POSTERS.raga, songs: ["s4"] },
  { id: "al5", title: "Desert Verse", type: "Original Soundtrack", movie: "m6", artist: "p5", year: "2025", language: "Rajasthani", cover: POSTERS.desert, songs: ["s7"] },
  { id: "al6", title: "Neon Diaries", type: "Independent Album", movie: null, artist: "p8", year: "2025", language: "Hindi", cover: POSTERS.temple, songs: ["s3", "s6", "s7"] },
];

export const getAlbum = (id) => ALBUMS.find((a) => a.id === id);
export const albumForSong = (songId) => ALBUMS.find((a) => a.songs.includes(songId) && a.type === "Original Soundtrack") || ALBUMS.find((a) => a.songs.includes(songId));
export const albumsForPerson = (id) => ALBUMS.filter((a) => a.artist === id || a.songs.some((sid) => { const s = getSong(sid); return s && (s.singer === id || s.composer === id || s.lyricist === id); }));

export const GENRES = ["Thriller", "Drama", "Crime", "Noir", "Epic", "Adventure", "Mystery", "Musical", "Sci-Fi"];
export const YEARS = ["2025", "2024"];
export const PLATFORMS_ALL = ["Netflix", "Prime Video", "JioHotstar", "SonyLIV", "ZEE5", "Sun NXT", "aha", "YouTube", "Theatres"];

// Filming locations (Follow the Film → travel ecosystem)
export const LOCATION_MAP = {
  m1: [
    { name: "Munnar Tea Hills", city: "Munnar", state: "Kerala", note: "The mist-wrapped opening sequence." },
    { name: "Fort Kochi", city: "Kochi", state: "Kerala", note: "The old-town chase in the rain." },
  ],
  m2: [{ name: "Dharavi & Colaba", city: "Mumbai", state: "Maharashtra", note: "The neon night-market streets." }],
  m3: [
    { name: "Brihadeeswara Temple", city: "Thanjavur", state: "Tamil Nadu", note: "The coronation sequence." },
    { name: "Hogenakkal Falls", city: "Dharmapuri", state: "Tamil Nadu", note: "The great river journey." },
  ],
  m4: [{ name: "Yarada Beach", city: "Visakhapatnam", state: "Andhra Pradesh", note: "The fog-bound coastline." }],
  m5: [{ name: "Ghats of the Ganga", city: "Varanasi", state: "Uttar Pradesh", note: "The dawn riyaaz scenes." }],
  m6: [{ name: "Sam Sand Dunes", city: "Jaisalmer", state: "Rajasthan", note: "The desert crossing." }],
  m7: [
    { name: "Hampi Ruins", city: "Hampi", state: "Karnataka", note: "The ancient temple exterior." },
    { name: "Bengaluru", city: "Bengaluru", state: "Karnataka", note: "The neon future-city." },
  ],
};

export const locationsForMovie = (id) => (LOCATION_MAP[id] || []).map((l) => ({ ...l, movieId: id }));

export const ALL_LOCATIONS = MOVIES.flatMap((m) => (LOCATION_MAP[m.id] || []).map((l) => ({ ...l, movie: m })));

// Contextual cross-portal links per state (do not tightly couple; simple outbound links)
export const ecosystemLinks = (state) => {
  if (state === "Kerala") return [
    { label: "Explore on Kerala.com", url: "https://kerala.com" },
    { label: "Plan a trip · KeralaTravels", url: "https://keralatravels.com" },
    { label: "Book a taxi · KeralaTaxi", url: "https://keralataxi.com" },
  ];
  return [
    { label: `Explore ${state} on Indias.com`, url: "https://indias.com" },
    { label: "Plan a trip", url: "https://indias.com" },
    { label: "Find nearby airports", url: "https://indianairports.com" },
  ];
};

// Trailers & Gallery
const BD = IMG;
export const BACKDROPS = {
  m1: BD + "8c3ed5d214cd611cf3deebda119bb54e08622d790c6721126ad8a34ef2d2d9bf.jpeg",
  m2: BD + "65d208c5055b5787b8a32feca24e71bbb43437f75ce78a66b8243f0fa35aaa53.jpeg",
  m3: BD + "bcedf558e406055004103a6a36eed7f15ffeb4a14476fbed1de35cb09d1ae6b1.jpeg",
  m4: BD + "a29f9fb000d77ae784b332c6a9acbaabc664e922f88195d887d6fe2587e881ca.jpeg",
  m5: BD + "6367bdc1e617839b69b15ad383bd0664a96b25dc6a0fd4fcaf5530a498180e4d.jpeg",
  m6: BD + "b10909a803b6243ef3cdbab6f8c39dc45f5ee0ec154d6200f42e8392f6db5cc5.jpeg",
  m7: BD + "a497a8d8ea9abfa29f490d1139f0b75bc9e0e349f0cc93ce396221316b7b8a45.jpeg",
};
const BTS = [
  "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
];
export const galleryForMovie = (id) => {
  const m = getMovie(id);
  return [BACKDROPS[id], m?.image, ...BTS].filter(Boolean);
};

// Map coordinates (approx % positions on a portrait India map)
export const LOC_COORDS = {
  Munnar: { x: 39, y: 80 }, Kochi: { x: 37, y: 83 }, Mumbai: { x: 28, y: 58 },
  Thanjavur: { x: 47, y: 79 }, Dharmapuri: { x: 45, y: 76 }, Visakhapatnam: { x: 55, y: 62 },
  Varanasi: { x: 50, y: 40 }, Jaisalmer: { x: 30, y: 40 }, Hampi: { x: 41, y: 72 }, Bengaluru: { x: 43, y: 75 },
};
export const INDIA_MAP_IMG = "https://static.prod-images.emergentagent.com/jobs/c6af1a77-2b65-44c2-9c4e-049400224684/images/609ab8e5c3002efd52a31afbd8f5bd6580078bc79ea815720da47c604e4b7e26.jpeg";

// CinemaPulse charts — Top tracks per language (methodology-transparent, ranked)
const d = (v) => v; // delta helper (number = up/down, 0 = steady, "new")
export const CHART_LANGS = ["India", "Hindi", "Malayalam", "Tamil", "Telugu", "Punjabi"];
export const CHARTS = {
  India: [
    { rank: 1, title: "Star River", artist: "Aditi Rao", film: "River of Stars", delta: 2, weeks: 6, songId: "s8" },
    { rank: 2, title: "Neon Nights", artist: "Noor Kaur", film: "Neon Bazaar", delta: "new", weeks: 1, songId: "s6" },
    { rank: 3, title: "Mazhavil", artist: "Aditi Rao", film: "The Last Monsoon", delta: -1, weeks: 9, songId: "s1" },
    { rank: 4, title: "Kaadhal Neruppu", artist: "Aditi Rao", film: "River of Stars", delta: 1, weeks: 5, songId: "s2" },
    { rank: 5, title: "Raat Rani", artist: "Noor Kaur", film: "Indie", delta: -2, weeks: 12, songId: "s3" },
    { rank: 6, title: "Megha Sandesh", artist: "Pandit R. Sharma", film: "Aurora Raga", delta: 0, weeks: 4, songId: "s4" },
    { rank: 7, title: "Desert Wind", artist: "Noor Kaur", film: "Desert Verse", delta: 3, weeks: 2, songId: "s7" },
    { rank: 8, title: "Kadal Pearl", artist: "Aditi Rao", film: "The Last Monsoon", delta: -1, weeks: 7, songId: "s5" },
  ],
  Hindi: [
    { rank: 1, title: "Neon Nights", artist: "Noor Kaur", film: "Neon Bazaar", delta: "new", weeks: 1, songId: "s6" },
    { rank: 2, title: "Raat Rani", artist: "Noor Kaur", film: "Indie", delta: 1, weeks: 12, songId: "s3" },
    { rank: 3, title: "Megha Sandesh", artist: "Pandit R. Sharma", film: "Aurora Raga", delta: -1, weeks: 4, songId: "s4" },
    { rank: 4, title: "Sheher Ki Raat", artist: "Arjun Dev", film: "Neon Bazaar", delta: 2, weeks: 3 },
    { rank: 5, title: "Ishq Purana", artist: "Meera Nair", film: "Aurora Raga", delta: 0, weeks: 8 },
    { rank: 6, title: "Chaandni", artist: "Noor Kaur", film: "Indie", delta: 4, weeks: 2 },
  ],
  Malayalam: [
    { rank: 1, title: "Mazhavil", artist: "Aditi Rao", film: "The Last Monsoon", delta: 0, weeks: 9, songId: "s1" },
    { rank: 2, title: "Kadal Pearl", artist: "Aditi Rao", film: "The Last Monsoon", delta: 1, weeks: 7, songId: "s5" },
    { rank: 3, title: "Mizhiyil", artist: "Vikram Suresh", film: "Silent Coast", delta: "new", weeks: 1 },
    { rank: 4, title: "Thiralukal", artist: "Aditi Rao", film: "The Last Monsoon", delta: -1, weeks: 5 },
    { rank: 5, title: "Kaattu", artist: "R. Chandran", film: "Silent Coast", delta: 2, weeks: 3 },
  ],
  Tamil: [
    { rank: 1, title: "Star River", artist: "Aditi Rao", film: "River of Stars", delta: 0, weeks: 6, songId: "s8" },
    { rank: 2, title: "Kaadhal Neruppu", artist: "Aditi Rao", film: "River of Stars", delta: 1, weeks: 5, songId: "s2" },
    { rank: 3, title: "Kadal Osai", artist: "Leela Krishnan", film: "River of Stars", delta: "new", weeks: 1 },
    { rank: 4, title: "Poongatru", artist: "R. Chandran", film: "River of Stars", delta: -1, weeks: 8 },
    { rank: 5, title: "Vaanam", artist: "Vikram Suresh", film: "River of Stars", delta: 3, weeks: 2 },
  ],
  Telugu: [
    { rank: 1, title: "Sagara Geetham", artist: "Leela Krishnan", film: "Silent Coast", delta: "new", weeks: 1 },
    { rank: 2, title: "Manasu", artist: "R. Chandran", film: "Silent Coast", delta: 1, weeks: 4 },
    { rank: 3, title: "Poddu Poddu", artist: "Aditi Rao", film: "Silent Coast", delta: -1, weeks: 6 },
    { rank: 4, title: "Cosmic Raaga", artist: "R. Chandran", film: "Cosmic Temple", delta: 2, weeks: 3 },
  ],
  Punjabi: [
    { rank: 1, title: "Chan Mahi", artist: "Noor Kaur", film: "Indie", delta: 0, weeks: 5 },
    { rank: 2, title: "Pind Diyan", artist: "Noor Kaur", film: "Indie", delta: "new", weeks: 1 },
    { rank: 3, title: "Rangla", artist: "Arjun Dev", film: "Indie", delta: 1, weeks: 4 },
  ],
};
